import n from"styled-components";import{theme as i}from"../../../theme.js";const t=n.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
`,o=n.div`
  padding-left: ${i.spacing*12}px;
  > p {
    margin: 0 0 ${i.spacing}px 0};
    color: ${i.colors.gray[600]};
    line-height: 24px;
  }
  > img {
    max-width: 300px;
    height: auto;
    obecjt-fit: contain;
  }
  > button {
    margin: 0 0 ${i.spacing}px 0};
  }
`;export{t as Container,o as ContentContainer};
